import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../../services/api.service';
import { ApiResponse } from '../../shared/types';
import {
  PlanChangeSettingsData,
  PlanChangeSettingsSource,
  PlanChangeSettingsUpdatePayload,
} from '../../services/plan-change-settings.service';

/**
 * CWS-1598: membership plan changes are switched on per company by Way, from
 * the super-admin company page. Returns a `PlanChangeSettingsSource` so the
 * shared settings panel can be pointed at one company's settings.
 */
@Injectable({ providedIn: 'root' })
export class MembershipPlanChangeSettingsService {
  private readonly api = inject(ApiService);

  private path(companyId: string): string {
    return `admin/super-admin/companies/${companyId}/membership-plan-change-settings`;
  }

  getSettings(companyId: string): Observable<ApiResponse<PlanChangeSettingsData>> {
    return this.api.getWithSuperAdminToken<PlanChangeSettingsData>(this.path(companyId));
  }

  updateSettings(
    companyId: string,
    payload: PlanChangeSettingsUpdatePayload
  ): Observable<ApiResponse<PlanChangeSettingsData>> {
    return this.api.putWithSuperAdminToken<PlanChangeSettingsData>(this.path(companyId), payload);
  }

  forCompany(companyId: string): PlanChangeSettingsSource {
    return {
      getSettings: () => this.getSettings(companyId),
      updateSettings: payload => this.updateSettings(companyId, payload),
    };
  }
}
